import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';

import { Observable, Subscription } from 'rxjs';
import { StrategyResponse, TopicModel } from '@generativ/much-smarter-models';
import { ExerciseService } from '../../exercise.service';
import { MultiChoiceComponent } from '../../exercise-problem/multi-choice/multi-choice.component';
import { UtilitiesService } from '../../../../shared/utilities.service';
import { ContentViewerComponent } from '../../../../shared/content-viewer/content-viewer.component';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap/tooltip';
import { SpinnerComponent } from '../../../../shared/spinner/spinner.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-lesson-strategy-topic',
    templateUrl: './exercise-strategy-topic.component.html',
    styleUrls: ['../exercise-strategy.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ContentViewerComponent, MultiChoiceComponent, NgbTooltip, RouterLink, SpinnerComponent, AsyncPipe]
})
export class ExerciseStrategyTopicComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  strategyResponseObservable: Observable<StrategyResponse>;
  exerciseId: number;

  readyToContinue = false;

  @ViewChild(MultiChoiceComponent)
  private multiChoiceComponent: MultiChoiceComponent<TopicModel>;

  constructor(private activatedRoute: ActivatedRoute,
              private utilitiesService: UtilitiesService,
              private exerciseService: ExerciseService) {
  }

  ngOnInit() {
    this.subscriptions.add(this.activatedRoute.params.subscribe((params) => {
      if (params['exerciseId']) {
        this.exerciseId = +params['exerciseId'];
        this.strategyResponseObservable = this.exerciseService.getInfoForStrategyProblem(params['exerciseId']);
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  handleSelectedTopic(problemId: number) {
    this.exerciseService.identifyTopicForExercise(problemId).subscribe(data => {
      this.readyToContinue = true;
      this.multiChoiceComponent.setRightOption(+data);
    });
  }
}

